import { useQuery } from '@tanstack/react-query'

import { NotificationQuery } from './NotificationQuery'

export const chatNotificationQuery: NotificationQuery = {
  getNotificationsQueryKey() {
    return ['ws', 'chat', 'notificationCount']
  },

  useNotificationsQuery() {
    return useQuery<number>({
      queryKey: this.getNotificationsQueryKey(),
      queryFn: () => 0,
      staleTime: Infinity
    })
  }
}
